module.exports = __webpack_public_path__ + "img/noimage.dfc8aafb.png";